var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { layout } from 'styled-system';
import { validate } from '@ally/aos-utils';
import { muiSuccessFill } from '@ally/metronome-icons';
import { Box, Button, Checkbox, FormText, Icon, Link, Space, TextBody, upToLg, upToMd, } from '@ally/metronome-ui';
import { delSavedUsername, getSavedUsernameSliceAndToken, } from '@ally/transmitigator';
import { useForm } from '@ally/use-form';
import { ChooseEnrollLOBModal } from '../../../../Modals';
import { FeatureFlag, logRocketTrack, useLogRocketTracking, } from '../../../../Utils';
import { FormField, LoginHeading } from '../../Layout/Layout';
import LoginErrorBanner from './LoginErrorBanner';
import { LoginNotificationMBoxes } from './LoginMbox/LoginNotificationMBoxes';
var StyledForm = styled.form(layout);
var PasswordHintSuccess = function (_a) {
    var navigateToForgotPassword = _a.navigateToForgotPassword;
    return (React.createElement(Box, { display: "flex", flexDirection: "column", mb: "sm", width: upToMd(12, 8) },
        React.createElement(Box, { display: "flex", alignItems: "flex-start", mb: "sm" },
            React.createElement(Icon, { icon: muiSuccessFill, fill: "success", size: "lg" }),
            React.createElement(Space, { ml: "xs" },
                React.createElement(TextBody, { size: "sm", tag: "span" }, "We sent a password hint based on your delivery preference."))),
        React.createElement(Box, { mb: "sm" },
            React.createElement(TextBody, { tag: "p", size: "sm" }, "You should see it within a few minutes. If you don't, we can send it again.")),
        React.createElement(Button, { withAllyTM: "forgotPassword-resendPasswordHint", variant: "link", text: "Resend password hint", onClick: navigateToForgotPassword })));
};
var FORM_ID = 'ally-login-login-form';
var getSType = function (redirectPathState) {
    switch (redirectPathState) {
        case 'UseTicket':
            return 'ts';
        case 'UseSession':
        default:
            return 'jt';
    }
};
var StyledLoginErrorBanner = styled(function (props) { return React.createElement(LoginErrorBanner, __assign({}, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 510px;\n"], ["\n  max-width: 510px;\n"])));
export var LoginFormContent = function (_a) {
    var actions = _a.actions, cancelButton = _a.cancelButton, error = _a.error, hostServices = _a.hostServices, isInPortal = _a.isInPortal, logger = _a.logger, maybeRedirectContext = _a.maybeRedirectContext, navigateToForgotPassword = _a.navigateToForgotPassword, navigateToForgotUsername = _a.navigateToForgotUsername, navigateToOleCustomer = _a.navigateToOleCustomer, passwordHintMethod = _a.passwordHintMethod, _b = _a.status, status = _b === void 0 ? 'None' : _b, _c = _a.username, payloadUsername = _c === void 0 ? '' : _c, variation = _a.variation;
    useLogRocketTracking(logger, 'login-transmit-login-load');
    React.useEffect(function () {
        hostServices === null || hostServices === void 0 ? void 0 : hostServices.analytics.trackPageView({
            eventType: 'pageview',
            pageName: 'AOS:Login:Home',
        });
    }, []);
    var isLegacyAAOSOLEEnabled = variation(FeatureFlag.LegacyAAOSOLE, true);
    var _d = __read(React.useState(false), 2), hasClearedUsername = _d[0], setHasClearedUsername = _d[1];
    var _e = __read(getSavedUsernameSliceAndToken(), 2), _f = _e[0], usernameSlice = _f === void 0 ? payloadUsername : _f, usernameToken = _e[1];
    var _g = __read(React.useState(usernameToken), 2), rememberMeToken = _g[0], setRememberMeToken = _g[1];
    var _h = __read(React.useState(!!usernameSlice && !!usernameToken), 2), hasRememberMeFlag = _h[0], setRememberMeFlag = _h[1];
    var _j = __read(React.useState(false), 2), hasSlowConnection = _j[0], setHasSlowConnection = _j[1];
    var _k = __read(React.useState('Login'), 2), loginTitle = _k[0], setLoginTitle = _k[1];
    var WIDTH = isInPortal ? 12 : upToMd(12, 6);
    var handleForgotPasswordClick = function (e) {
        e.preventDefault();
        if (isInPortal)
            window.location.href = '/forgot-password';
        else
            navigateToForgotPassword();
    };
    var handleForgotUsernameClick = function (e) {
        e.preventDefault();
        if (isInPortal) {
            window.location.href = '/forgot-username';
        }
        else {
            navigateToForgotUsername();
        }
    };
    var handleOnlineEnrollClick = function (e) {
        e.preventDefault();
        if (isInPortal) {
            window.location.href = '/enroll';
        }
        else {
            navigateToOleCustomer();
        }
    };
    var getInitialState = function () {
        if (window.mirageEnabled) {
            return {
                username: 'emulatorUser',
                password: 'emulatorPassword',
                rememberMeFlag: false,
            };
        }
        return {
            username: isInPortal ? '' : usernameSlice,
            password: '',
            rememberMeFlag: hasRememberMeFlag,
        };
    };
    var submit = function (_a) {
        var username = _a.username, password = _a.password;
        logRocketTrack('login-transmit-login-submit');
        actions === null || actions === void 0 ? void 0 : actions.loginWithUser({
            username: rememberMeToken ? undefined : username,
            password: password,
            rememberMeToken: rememberMeToken,
            rememberMeFlag: !rememberMeToken && hasRememberMeFlag,
            journey_version: 'v2',
            sType: maybeRedirectContext
                ? getSType(maybeRedirectContext.redirectPath.state)
                : 'jt',
        });
    };
    var getRules = function (values) { return ({
        username: [
            { condition: !values.username, message: 'Please enter your username.' },
            {
                condition: !!(values.username && values.username.length < 4),
                message: 'Your username must contain at least 4 characters.',
            },
        ],
        password: [
            { condition: !values.password, message: 'Please enter your password.' },
        ],
    }); };
    var _l = useForm({
        submit: submit,
        validate: validate(getRules),
        initialState: getInitialState(),
        formId: FORM_ID,
    }), values = _l.values, errors = _l.errors, handleChange = _l.handleChange, handleSubmit = _l.handleSubmit, resetFields = _l.resetFields;
    // If the remember me token is present and the user has decided to type a
    // new username, then ensure we're not passing the rememberMeToken to login.
    // This is how it works in AOS today. If they edit the field, it passes in
    // the edited value as the username.
    var handleUsernameChange = function (e) {
        if (rememberMeToken)
            setRememberMeToken(undefined);
        handleChange(e);
    };
    function handleCheckboxChange(event) {
        var notChecked = !event.currentTarget.checked;
        if (notChecked) {
            delSavedUsername();
            setRememberMeFlag(false);
            if (!hasClearedUsername) {
                resetFields('username');
                setHasClearedUsername(true);
            }
            return;
        }
        setRememberMeFlag(true);
    }
    React.useEffect(function () {
        if (error && status !== 'Loading') {
            setHasSlowConnection(false);
            resetFields('password');
        }
    }, [error, status]);
    React.useEffect(function () {
        if (status === 'Loading') {
            var timeout_1 = setTimeout(function () {
                setHasSlowConnection(true);
            }, 6000);
            return function () { return clearTimeout(timeout_1); };
        }
        return undefined;
    }, [status]);
    var usernameRef = React.useRef(null);
    var passwordRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        if (usernameRef.current && errors.username !== '') {
            usernameRef.current.focus();
        }
        if ((passwordRef.current && errors.password !== '') ||
            (errors.password === '' && error && ((_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.value) === '')) {
            passwordRef.current.focus();
        }
    }, []);
    var onSubmit = function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (status !== 'Loading') {
            handleSubmit();
        }
    };
    var search = useLocation().search;
    var wealthRedirectPath = '/ext-wealth/prospect-assessment';
    var investSimplyPath = [
        '/open-account/invest-simply/automated',
        '/open-account/invest-simply/self-directed',
    ];
    var optionalRedirectPath = new URLSearchParams(search).get('redirect');
    var shouldRenderWealthHeaderContent = optionalRedirectPath === wealthRedirectPath;
    var shouldRenderCustomInvestHeaderContent = investSimplyPath.includes(optionalRedirectPath);
    React.useEffect(function () {
        if (shouldRenderWealthHeaderContent) {
            setLoginTitle('Log In to Schedule a Call');
        }
        if (shouldRenderCustomInvestHeaderContent) {
            setLoginTitle('Log In to Access Invest Simply');
        }
        if (search.includes('mortgage')) {
            setLoginTitle('You’re in the right place. Things just look different.');
        }
    }, [search, shouldRenderWealthHeaderContent]);
    return (React.createElement(React.Fragment, null,
        !isInPortal && React.createElement(LoginHeading, { title: loginTitle, focusOnMount: false }),
        passwordHintMethod && (React.createElement(PasswordHintSuccess, { navigateToForgotPassword: navigateToForgotPassword })),
        React.createElement(StyledLoginErrorBanner, { error: error }),
        hasSlowConnection && (React.createElement(Space, { mb: "sm" },
            React.createElement(TextBody, { tag: "p", size: "sm" }, "The request seems to be taking more time than usual. Please wait."))),
        React.createElement(LoginNotificationMBoxes, { rawQueryParams: search, isInPortal: isInPortal || false }),
        React.createElement(Box, { display: "flex", width: WIDTH, maxWidth: "800px" },
            React.createElement(StyledForm, { method: "post", onSubmit: onSubmit, width: 12, id: FORM_ID, autoComplete: "off" },
                React.createElement(FormField, { isInPortal: isInPortal },
                    React.createElement(FormText, { variant: "input", labelContent: "Username", id: "username", inputType: "text", onChange: handleUsernameChange, value: values.username || '', "data-testid": "login-username", errorNotification: { message: errors.username }, maxLength: 50, required: true, ref: usernameRef })),
                React.createElement(Box, { display: "flex", flexDirection: upToLg('column', 'row'), width: 12, mb: "md" },
                    React.createElement(FormField, { isInPortal: isInPortal, mb: "none" },
                        React.createElement(FormText, { variant: "input", labelContent: "Password", adornment: "passwordMask", id: "password", inputType: "password", onChange: handleChange, value: values.password || '', "data-testid": "login-password", errorNotification: { message: errors.password }, maxLength: 50, required: true, "aria-describedby": "password-helper", ref: passwordRef, isPrivate: true }))),
                React.createElement(FormField, { isInPortal: isInPortal, flexDirection: "row", alignItems: "center" },
                    React.createElement(Button, { type: "submit", text: "Log In", variant: "login", "data-testid": "login-submit", loading: status === 'Loading', mr: "sm", disableFullWidthSmDown: true }),
                    !isInPortal && (React.createElement(Checkbox, { label: "Save username", name: "rememberMeFlag", isChecked: hasRememberMeFlag, onChange: handleCheckboxChange })),
                    cancelButton),
                React.createElement(Box, { width: upToMd(12, 8) },
                    React.createElement(TextBody, { size: "sm", tag: "p" },
                        "Forgot",
                        ' ',
                        React.createElement(Link, { withAllyTM: "forgotUsername", onClick: handleForgotUsernameClick, text: "username", to: "/forgot-username" }),
                        ' ',
                        "or",
                        ' ',
                        React.createElement(Link, { onClick: handleForgotPasswordClick, text: "password", to: "/forgot-password" }),
                        "?"),
                    !isInPortal && (React.createElement(TextBody, { size: "sm", tag: "p" },
                        isLegacyAAOSOLEEnabled ? (React.createElement(ChooseEnrollLOBModal, { isInPortal: isInPortal, navigateToOleCustomer: navigateToOleCustomer })) : (React.createElement(Link, { onClick: handleOnlineEnrollClick, text: "Create a profile", to: "/enroll" })),
                        ' ',
                        "to manage your account online")))))));
};
var templateObject_1;
//# sourceMappingURL=LoginForm.js.map